function parseEnvBoolean(value: unknown, fallback = false) {
  if (value === undefined || value === null || value === "")
    return fallback;

  return String(value).toLowerCase() === "true";
}

export const HEALTHCARE_USE_MOCKS = parseEnvBoolean(
  import.meta.env.VITE_HEALTHCARE_USE_MOCKS,
  false,
);

export const HEALTHCARE_SERVICES_USE_MOCKS = parseEnvBoolean(
  import.meta.env.VITE_HEALTHCARE_SERVICES_USE_MOCKS,
  false,
);

export const WORKSPACE_USE_MOCKS = parseEnvBoolean(
  import.meta.env.VITE_WORKSPACE_USE_MOCKS,
  false,
);

export const HEALTHCARE_BOARDING_USE_MOCKS = parseEnvBoolean(
  import.meta.env.VITE_HEALTHCARE_BOARDING_USE_MOCKS,
  HEALTHCARE_USE_MOCKS,
);

export const HEALTHCARE_SERVICE_ROOMS_USE_MOCKS = parseEnvBoolean(
  import.meta.env.VITE_HEALTHCARE_SERVICE_ROOMS_USE_MOCKS,
  HEALTHCARE_BOARDING_USE_MOCKS,
);

export const HEALTHCARE_CLINICAL_CATALOG_USE_MOCKS = parseEnvBoolean(
  import.meta.env.VITE_HEALTHCARE_CLINICAL_CATALOG_USE_MOCKS,
  false,
);

export const HEALTHCARE_MEDICATION_USE_MOCKS = parseEnvBoolean(
  import.meta.env.VITE_HEALTHCARE_MEDICATION_USE_MOCKS,
  false,
);

export const VISIT_WORKBENCH_USE_MOCKS = parseEnvBoolean(
  import.meta.env.VITE_VISIT_WORKBENCH_USE_MOCKS,
  HEALTHCARE_USE_MOCKS,
);

/**
 * Does the live Vet Visit carry `consultation_seconds` yet? Flip to true ONLY once the backend
 * has deployed the consultation-timer fields (docs/README.visit-consultation-timer-backend-prompt.md).
 * The visit list asks for an explicit field set, and one unknown column fails the whole query —
 * the list would then drop to its minimal fallback. Until then the list's duration column stays
 * hidden on the real server.
 */
export const VISIT_CONSULTATION_FIELDS_LIVE = parseEnvBoolean(
  import.meta.env.VITE_VISIT_CONSULTATION_FIELDS_LIVE,
  false,
);

export const PET_PROFILE_USE_MOCKS = parseEnvBoolean(
  import.meta.env.VITE_PET_PROFILE_USE_MOCKS,
  VISIT_WORKBENCH_USE_MOCKS,
);
